export const categories = [
  {
    slug: 'hot-comment',
    name: '热评现场',
    desc: '评论区永远比正文精彩，一句话直接封神。',
    icon: 'ri-chat-smile-2-line',
    count: 268,
    accent: 'primary',
  },
  {
    slug: 'danmaku',
    name: '弹幕玩梗',
    desc: '满屏飞过的梗，比剧情本身还让人上头。',
    icon: 'ri-movie-2-line',
    count: 195,
    accent: 'accent',
  },
  {
    slug: 'iconic-scene',
    name: '名场面',
    desc: '被网友反复回放、截图、做成表情包的经典瞬间。',
    icon: 'ri-star-smile-line',
    count: 341,
    accent: 'secondary',
  },
  {
    slug: 'group-chat',
    name: '群聊高能',
    desc: '群里一人一句接下去，笑到隔壁都来敲门。',
    icon: 'ri-group-2-line',
    count: 152,
    accent: 'primary',
  },
  {
    slug: 'meme-reply',
    name: '接梗合集',
    desc: '全网都在接同一句话，接得好直接出圈。',
    icon: 'ri-links-line',
    count: 224,
    accent: 'accent',
  },
  {
    slug: 'meme-gif',
    name: '梗图速递',
    desc: '一张图说完整件事，转发量比正片还高。',
    icon: 'ri-image-2-line',
    count: 310,
    accent: 'secondary',
  },
];

export const getCategoryBySlug = (slug: string) =>
  categories.find((item) => item.slug === slug);

export const getCategoryName = (slug: string) =>
  categories.find((item) => item.slug === slug)?.name ?? '玩梗现场';